import AxiosInstance from "../instance";
import {emptyFn, returnValidResponse} from "../utils";

const getImageContent = async (formData: FormData) => {
    const response = await AxiosInstance.getInstance().post("/content-moderation", formData);
    return response;
};

const getOCRLanguages = async () => {
    const response = await AxiosInstance.getInstance().get("/content-moderation/language-codes").catch(emptyFn);
    return returnValidResponse(response);
};


export {getImageContent, getOCRLanguages};


// WEBPACK FOOTER //
// ./src/api/models/ImageContent.ts